// -----------------------------------------------------------------------------------------------------
// @ Constantes Regex
// -----------------------------------------------------------------------------------------------------

/**
 * @constant
 * @desc Validación Texto sin números ni caracteres especiales
 */
export const NAME_PATTERN: RegExp = /^[A-Za-zÁ-ÿ .]+$/i;

/**
 * @constant
 * @desc Validación Correo Electrónico
 */
export const EMAIL_PATTERN: RegExp = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;

/**
 * @constant
 * @desc Validación número telefónico
 */
export const PHONE_PATTERN: RegExp = /^[0-9 +()]+$/i;

/**
 * @constant
 * @desc Validación de campos tipo Texto en General
 */
export const PARAM_NAME_PATTERN: RegExp = /^[A-Za-z0-9Á-ÿ\-()./+*[\]|_# ]+$/i;

